import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import Upgrade from 'modules/core/components/Upgrade'
import { UpgradeActions } from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const UpsellFixedTimeBudgetSettings = ({}) => {
  const { company } = useCurrentSession()
  const currentSubscriptionPlan = company.subscription.plan
  const isLegacy = company.subscription.isPre2022Legacy
  const [upsellRequested, setUpsellRequested] = React.useState(false)

  const onCloseContact = () => {
    setUpsellRequested(false)
  }

  return (
    <Box flexDirection="column" gap="s24" width="s400">
      <Upgrade.Large
        currentPlanName={currentSubscriptionPlan}
        action={{
          type: UpgradeActions.contactCX,
          onClick: () => {
            setUpsellRequested(true)
          },
        }}
      />
      {upsellRequested && (
        <RequestUpgradeModal
          moduleRequested={AvailableModules.projects}
          featureRequested={Features.projects_budget}
          requestReason={isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature}
          onClose={onCloseContact}
        />
      )}
    </Box>
  )
}
